import { render, staticRenderFns } from "./BaseTextArea.vue?vue&type=template&id=6ecdb8ec&scoped=true"
import script from "./BaseTextArea.vue?vue&type=script&lang=js"
export * from "./BaseTextArea.vue?vue&type=script&lang=js"
import style0 from "./BaseTextArea.vue?vue&type=style&index=0&id=6ecdb8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecdb8ec",
  null
  
)

export default component.exports